module.exports = __webpack_public_path__ + "img/20190612162029710.e5a4145d.png";